var map = {
	"./american-express.png": 499,
	"./discover.png": 500,
	"./jcb.png": 501,
	"./mastercard.png": 502,
	"./savvas-logo.jpg": 1619,
	"./visa.png": 503,
	"./wr-favicon-white.png": 504,
	"./wr-logo-white.png": 219,
	"./wr-logo.png": 505
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 665;



//////////////////
// WEBPACK FOOTER
// ./assets/images/logos .\.jpg*|.\.png*
// module id = 665
// module chunks = 0